import './new-daily-time-record.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateDailyTimeRecord } from "@core/query/daily-time-record.query";
import { DailyTimeRecordFormRule, DailyTimeRecordFormSchema } from "@core/form/form.rule";
import { dailyTimeRecordFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormDailyTimeRecord from "../form-daily-time-record/form-daily-time-record";

export function DailyTimeRecord() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateDailyTimeRecord } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New DailyTimeRecord is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addDailyTimeRecord, isLoading: isCreating } =
    useQyCreateDailyTimeRecord(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<DailyTimeRecordFormSchema>({
    defaultValues: dailyTimeRecordFormDefault,
    resolver: zodResolver(DailyTimeRecordFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: DailyTimeRecordFormSchema) => {
    const formData = mapCreateDailyTimeRecord(form);
    addDailyTimeRecord(formData);
  };
  const handleValidateError = (err: FieldErrors<DailyTimeRecordFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="DailyTimeRecord" className="daily-time-record">
      <HeaderContent
        title="New Daily Time Record"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormDailyTimeRecord />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default DailyTimeRecord;